'use strict';

module.exports = {
    backToPage: function () {
        $(document).on('click', '.back-to-page', function () {
            window.history.back();
            return false;
        });
    }
};
